/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StartBillrunStatus {
    PREVIOUS_BILLRUN_NOT_COMPLETED = 'PreviousBillrunNotCompleted',
    MISSING_IMPORTS = 'MissingImports',
    READY_TO_BE_STARTED = 'ReadyToBeStarted',
    STARTED = 'Started',
    COMPLETED = 'Completed',
    UNKNOWN = 'Unknown',
    TOO_EARLY = 'TooEarly',
}
